// src/redux/submissionSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_submission,
  add_submission,
  update_submission,
  delete_submission
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  submission: [],
  school_id:"",
  totalPages: 0,
  pageSize: 5,
  count: 0,
  activePage: 1,
  loading: false,
  subloading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    answer:"",
    remark:"",
    attachments:"",
  },
};



// Async Thunks for API Calls
export const fetchsubmission = createAsyncThunk(
  "submission/fetchsubmission",
  async ({ page, page_size,search,assignment_id,school_id,filter_fields, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_submission(page, page_size,search,assignment_id,school_id,filter_fields,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createsubmission = createAsyncThunk(
  "submission/createsubmission",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_submission(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatesubmission = createAsyncThunk(
  "submission/updatesubmission",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_submission(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletesubmission = createAsyncThunk(
  "submission/deletesubmission",
  async ({ id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_submission({ id }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// submission Slice
const submissionSlice = createSlice({
  name: 'submissions',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, answer,remark} = action.payload;
      state.formData = { id, answer,remark};
    },
    resetFormData(state) {
      state.formData = {
        answer:"",
    remark:"",
    attachments:"",
    assignment:""
      };
    },
    setsubmission(state, action) {
      state.submission = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
     
       // Fetch submission
       .addCase(fetchsubmission.pending, (state) => {
        state.loading = true;
        state.subloading = true;
      })
      .addCase(fetchsubmission.fulfilled, (state, action) => {
        state.loading = false;
        state.subloading = false;

        state.submission = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchsubmission.rejected, (state, action) => {
        state.loading = false;
        state.subloading = false;

        state.submission = [];
        state.error = action.payload;
      })

      // Add submission
      .addCase(createsubmission.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createsubmission.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createsubmission.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update submission
      .addCase(updatesubmission.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatesubmission.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatesubmission.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = true;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete submission
      .addCase(deletesubmission.pending, (state) => {
        state.loading = true;

      })
      .addCase(deletesubmission.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletesubmission.rejected, (state, action) => {
        state.loading = false;

        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setsubmission,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = submissionSlice.actions;
export default submissionSlice.reducer;
